var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import useTranslate from '../../../../localization/helpers';
import OthersCard from './OthersCard';
import { Icon } from '@iconify/react';
import { nanoid } from '@reduxjs/toolkit';
import { BubbleChatIcon } from 'hugeicons-react';
import { useNavigate } from 'react-router-dom';
import { useSetDocumentFilterMutation } from '../../../../application/features/chat/chat-api';
import { useAppSelector } from '../../../../application/store/useStore';
var CHAT_START_LOCATION = 'Assets';
var SubFolderContent = function (_a) {
    var machineId = _a.machineId, subfolderId = _a.subfolderId, subFolderContents = _a.subFolderContents, onBack = _a.onBack, searchText = _a.searchText, isFetchingSubContent = _a.isFetchingSubContent;
    var translate = useTranslate().translate;
    var theme = useTheme();
    var navigate = useNavigate();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var isXs = useMediaQuery('(max-width:600px)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var _b = __read(useState([]), 2), selectedDocuments = _b[0], setSelectedDocuments = _b[1];
    var _c = __read(useSetDocumentFilterMutation(), 2), setDocumentsFilter = _c[0], documentFilterLoading = _c[1].isLoading;
    var handleSelectToggle = function (id) {
        setSelectedDocuments(function (prev) {
            return prev.includes(id) ? prev.filter(function (item) { return item !== id; }) : __spreadArray(__spreadArray([], __read(prev), false), [id], false);
        });
    };
    var startDocumentsChat = function () { return __awaiter(void 0, void 0, void 0, function () {
        var conversation_id, documentsFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    conversation_id = nanoid();
                    documentsFilter = {
                        conversation_id: conversation_id,
                        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                        user_name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
                        chat_start_location: CHAT_START_LOCATION,
                        documents: selectedDocuments,
                        company_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id
                    };
                    return [4 /*yield*/, setDocumentsFilter(documentsFilter).unwrap()];
                case 1:
                    _a.sent();
                    navigate('/chats');
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Box, { sx: {
            height: __assign(__assign(__assign(__assign({ xs: 'calc(100svh - 450px)', sm: 'calc(100svh - 416px)' }, (isscreen600900 && { sm: 'calc(100svh - 416px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                ? { sm: '420px' }
                : iscreen9001200
                    ? { sm: 'calc( 100svh - 350px)' }
                    : {})), { overflowY: 'auto' })
        }, children: _jsxs(Grid, { container: true, spacing: 2, px: 0.5, children: [selectedDocuments.length > 0 && !isXs && (_jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Typography, { variant: 'body1', color: 'text.secondary', children: [selectedDocuments.length, " ", translate('knowledge.selected')] }), _jsx(IconButton, { size: 'medium', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: _jsx(BubbleChatIcon, {}) })] }) })), selectedDocuments.length >= 1 && isXs && (_jsx(Box, { position: 'fixed', width: '90%', bottom: 100, left: '50%', sx: {
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(33, 43, 54, 1)',
                        boxShadow: '0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33',
                        borderRadius: theme.spacing(1.5),
                        p: theme.spacing(1),
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        zIndex: 1
                    }, children: _jsxs(Box, { display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 1, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', children: [_jsx(IconButton, { size: 'Xs', style: { color: '#919EAB' }, onClick: function () { return setSelectedDocuments([]); }, children: _jsx(Icon, { icon: 'mingcute:close-line' }) }), _jsxs(Typography, { variant: 'subtitle2', fontWeight: 600, color: '#C4CDD5', children: [selectedDocuments.length, " ", translate('knowledge.selected')] })] }), _jsx(Button, { size: 'small', endIcon: _jsx(BubbleChatIcon, { width: 16, height: 16 }), variant: 'contained', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: translate('knowledge.startChat') })] }) })), !isFetchingSubContent && subFolderContents && subFolderContents.length <= 0 && (_jsx(Grid, { size: { xs: 12 }, sx: { textAlign: 'center', mt: 2 }, children: _jsx(Typography, { variant: 'subtitle1', children: translate('common.noRecordFound') }) })), !isFetchingSubContent && subFolderContents && subFolderContents.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Grid, { size: { xs: 12 }, children: _jsx(Typography, { variant: 'subtitle1', children: translate('common.files') }) }), subFolderContents === null || subFolderContents === void 0 ? void 0 : subFolderContents.map(function (content) { return (_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 4, md: iscreen9001200 ? 6 : 4 }, children: _jsx(OthersCard, { id: content.id, title: content.newFileName, disabled: !content.addedToKnowledgeBase, uploadingStatus: content.uploadingStatus, processingStatus: content.processingStatus, addedToKnowledgeBase: content.addedToKnowledgeBase, pdfFilePath: content.filePath, isSelected: selectedDocuments.includes(content.id), onToggleSelect: handleSelectToggle }) }, content.id)); })] }))] }) }));
};
export default SubFolderContent;
